import moment from 'moment'
import api from '../../services/service_report'
import apipos from '../../services/service_pos'
import apiItem from '../../services/service_item'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      host_list: [],
      report_data: [],
      search_text: '',
      host: '',
      now_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: '',
      item_start: '',
      item_end: '',
      branch: 0,
      item_data: []
    }
  },
  methods: {
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getReport()
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
          }
        },
        error => {
          console.log(error)
          this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', 'เชื่อมสาขาไม่ได้')
        }
      )
    },
    getItems () {
      var branch = 0
      if (this.branch === 0) {
        branch = this.$store.state.branch_list[0]
      } else {
        branch = this.branch
      }

      apiItem.listProduct(
        branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            result.data.forEach(val => {
              this.item_data.push({
                name: val['code'] + ': ' + val['name'],
                code: val['code']
              })
            })
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    },
    getReport () {
      var branch = 0
      if (parseInt(this.branch) !== 0) {
        branch = this.branch.id
      }
      var obj = {
        keyword: this.search_text,
        company_id: 1,
        branch_id: 1,
        id: branch
      }
      this.$store.commit('Loading')
      api.stockReport(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
            this.form_host = JSON.stringify(this.host)
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลรายงานไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    count_qty (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_qty']
      })
      return sum
    },
    count_use (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_input']
      })
      return sum
    },
    count_input (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['lot_use']
      })
      return sum
    },
    count_stock (obj) {
      var sum = 0
      // obj.forEach((v) => {
      if (obj.items) {
        obj.items.forEach(val => {
          sum += val['stock_qty']
        })
      }
      // })
      return sum
    }
  },
  mounted () {
    this.checkUser()
    this.getBranch()
    this.getHost()
    setTimeout(() => {
      this.getItems()
    }, 500)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/report_stock.js